<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="服务器名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=20
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="ip"
                    label="IP"
                    prop="ip"
                    :help="formErr.ip"
                    :validateStatus='!formErr.ip||formErr.ip==""?"":"error"'
            >
                <a-input
                        v-model="form.ip"
                        @change="(e) => {formErr.ip=''}"
                        @blur="(e) => {form.ip = e.target.value.trim();  }"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="registered_address"
                    label="注册地址"
                    prop="registered_address"
                    :help="formErr.registered_address"
                    :validateStatus='!formErr.registered_address||formErr.registered_address==""?"":"error"'
            >
                <a-input
                        v-model="form.registered_address"
                        @change="(e) => { formErr.registered_address=''}"
                        @blur="(e) => {  form.registered_address = e.target.value.trim() }"
                />
            </a-form-model-item>

            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="1"> 启用 </a-radio>
                    <a-radio :value="0"> 停用 </a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";

    export default {
        name: "serverForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig ,
                role:[],
                form: {
                    name:"",
                    ip:"",
                    registered_address:"",
                    status:1
                },
                formErr: {
                    name:"",
                    ip:"",
                    registered_address:"",
                    status:""
                },
                rules: {
                    name: [{required: true, message: "请输入服务器名称 ",  }, { whitespace: true, message: "请输入服务器名称 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    ip: [{required: true, message: "请输入ip ",  }, {  whitespace: true, message: "请输入ip " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.ip)}  , trigger: "blur"  }, ],
                    registered_address: [{required: true, message: "请输入注册地址 ",  }, { whitespace: true, message: "请输入注册地址 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.registered_address)}  , trigger: "blur"  },  ],

                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.serverManagement.EDIT_DATA(a).then(res => {
                        let {name,ip,registered_address,status}= res.data.data.info
                        this.form.name=name
                        this.form.ip=ip
                        this.form.registered_address=registered_address
                        this.form.status=status
                        this.form.id=a

                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.form.password=""
                this.formErr={   name:"", ip:"", registered_address:"", status:"" },
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.serverManagement.SUBMIT_ADD: url = API.serverManagement.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
